import PropTypes from 'prop-types';

import { StatusBadge } from '#/modules/commonComponents/badge';
import { getRepairItemStatusLabel } from '#/modules/crmMgmt/aftersales/repairItem/helper/repairItemStatus';

const RepairItemStatusBadge = ({ status, size = 'default', className }) => (
  <StatusBadge
    status={status}
    label={getRepairItemStatusLabel(status)}
    size={size}
    className={className}
  />
);

RepairItemStatusBadge.propTypes = {
  status: PropTypes.string,
  size: PropTypes.oneOf(['default', 'sm']),
  className: PropTypes.string,
};

export default RepairItemStatusBadge;
